import type {LDFlagSet} from 'launchdarkly-react-client-sdk';

export enum MockLaunchDarklyActionType {
  SET_FLAGS = 'LAUNCHDARKLY_SET_FLAGS',
}

interface SetFlagsAction {
  type: MockLaunchDarklyActionType.SET_FLAGS;
  flags: LDFlagSet;
}

export function setFlags(flags: LDFlagSet): SetFlagsAction {
  return {
    type: MockLaunchDarklyActionType.SET_FLAGS,
    flags,
  };
}

export type MockLaunchDarklyAction = SetFlagsAction;
